//定制专题
export const erpDirectAssistantRouter = [
  {
    path: '/service/erpDirectAssistant/synchronizeProducts',
    name: 'SynchronizeProducts',
    component: () => import('@/views/service/serviceProvider/erpDirectAssistant/SynchronizeProducts'),
    meta: {
      title: '同步产品',
      keepAlive: false
    }
  },
  {
    path: '/service/erpDirectAssistant/orderSynchronization',
    name: 'OrderSynchronization',
    component: () => import('@/views/service/serviceProvider/erpDirectAssistant/OrderSynchronization'),
    meta: {
      title: '订单同步归属配置',
      keepAlive: false
    }
  },
  {
    path: '/service/erpDirectAssistant/apiConfigure',
    name: 'ApiConfigure',
    component: () => import('@/views/service/serviceProvider/erpDirectAssistant/ApiConfigure'),
    meta: {
      title: 'API配置',
      keepAlive: false
    }
  }
]